import React, { PropsWithChildren, useEffect } from "react";
import styled from "@emotion/styled";
import { useEditor } from "@craftjs/core";
import { LeftPanel } from "./LeftPanel";
import { CenterPanel } from "./CenterPanel";
import { RightPanel } from "./RightPanel";

const ViewportDiv = styled.div`
  display: flex;
  flex: 1;
  height: 100vh !important;
  color: var(--builder-text-color);

  .component-selected {
    //position: relative;
    ::after {
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: block;
      pointer-events: none;
      border: dashed 1px #4492ed;
      box-shadow: 0 0 1px #4492ed;
    }
  }
`;
export interface IViewport {}

export const Viewport: React.FC<PropsWithChildren<IViewport>> = ({
  children,
}) => {
  const {
    actions: { setOptions },
  } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  useEffect(() => {
    if (!window) {
      return;
    }

    window.requestAnimationFrame(() => {
      // Notify doc site
      window.parent.postMessage(
        {
          LANDING_PAGE_LOADED: true,
        },
        "*"
      );

      setTimeout(() => {
        setOptions((options) => {
          options.enabled = true;
        });
      }, 200);
    });
  }, [setOptions]);

  return (
    <ViewportDiv className="viewport">
      <LeftPanel />
      <CenterPanel>{children}</CenterPanel>
      <RightPanel />
    </ViewportDiv>
  );
};
